import { MapTo } from '@adobe/aem-react-editable-components';
import ApyTermsTable, { ApyTermsTableEditConfig } from './ApyTermsTable';

export default MapTo('cob-corp-acquisition/components/creditonebank/apy-terms-table')(ApyTermsTable, ApyTermsTableEditConfig);